<template>
<div class="position-relative mt-3" id="productlineTable">

  <div class="actions text-right" id="productlineTable-showAddEditDialog">
    <button class="btn btn-primary icon-button" @click="showAddEditDialog = true" id="productlineTable-add-Button">
      <span class="btn-icon" id="productlineTable-addButton-span"><i class="fa fa-plus" aria-hidden="true" id="productlineTable-addButton-data"></i></span>
      {{ 'ADD' | translate }}
    </button>
  </div>

  <vodal :show="showAddEditDialog"
         :width="400"
         :closeOnEsc="true"
         :closeOnClickMask="false"
         :customStyles="{'top': '80px', 'bottom': 'auto', 'height': 'auto'}"
         animation="rotate"
         @hide="closeDialog">
    <productline-add-edit-dialog :edited="editedRow"
                              :subBrancheOptions="subBrancheOptions"
                              :existingProductlines="rows"
                              @save="onSaveNew"
                              @update="onUpdate"
                              @close="closeDialog"
                              id="productlineTable-addEditDialog"
    ></productline-add-edit-dialog>
  </vodal>
  <table class="table table-striped table-hover" id="productlineTable-tableData">
    <caption></caption>
    <tr>
      <th>Naam</th>
      <th>Omschrijving</th>
      <th>Enabled</th>
      <th></th>
    </tr>
    <template v-for="row in rows">
      <tr>
        <td>{{ row.name }}</td>
        <td>{{ row.description }}</td>
        <td>{{ row.enabled }}</td>
        <td id="productlineTable-tableButtons">
          <button class="btn btn-success icon-button icon-button-collapsed"
              v-tooltip="$options.filters.translate('EDIT')" @click="onEdit(row)" :id="'productlineTable-tableEditButton-'+row.name">
            <span class="btn-icon" :id="'productlineTable-tableEditSpan-'+row.name"><i class="fa fa-pencil" aria-hidden="true" :id="'productlineTable-tableEditData-'+row.name"></i></span>
          </button>
          <button class="btn btn-danger icon-button icon-button-collapsed"
              v-tooltip="$options.filters.translate('DELETE')" @click="confirmDelete(row)" :id="'productlineTable-tableDeleteButton'+row.name">
            <span class="btn-icon" :id="'productlineTable-tableDeleteSpan-'+row.name"><i class="fa fa-trash-o" aria-hidden="true" :id="'productlineTable-tableDeleteData-'+row.name"></i></span>
          </button>
        </td>
      </tr>
    </template>
  </table>
  <confirm-dialog :show="showDeleteConfirmDialog" :textLabel="'Are you sure you want to delete this?'"
              @hide-dialog="showDeleteConfirmDialog = false" @confirm="onRemove(selectedRow.id)">
            </confirm-dialog>
</div>
</template>

<script>
import RestService from '../../../service/RestService.js';
import ProductlineAddEditDialog from './ProductlineAddEditDialog';
import Datepicker from 'vuejs-datepicker';
import Vodal from 'vodal';
import GeneralConfigService from '../../../service/GeneralConfigService';
import ConfirmDialog from '../../dialog/ConfirmDialog.vue';

export default {
  components: { ProductlineAddEditDialog, Datepicker, Vodal, ConfirmDialog },
  data() {
    return {
      rest: this.initRestService(),
      filter: '',
      rows: [],
      newRows: [],
      editedRow: null,
      showAddEditDialog: false,
      showDeleteConfirmDialog: false,
      subBrancheOptions: [],
      selectedRow: null
    }
  },
  beforeMount() {
    this.loadRows();
    this.loadSubBranches();
  },
  methods: {
    initRestService() {
      return new RestService();
    },
    async loadRows() {
      const productlineResponse = await this.rest.getAllProductlineRows();
      this.rows = productlineResponse.data;
    },
    async loadSubBranches() {
      const resp = await this.rest.getAllSubbrancheRows();
      this.subBrancheOptions = resp.data;
    },
    async onSaveNew(row) {
      await this.rest.createProductlineRow(row);
      this.closeDialog();
      this.loadRows();
    },
    async onUpdate(row) {
      await this.rest.updateProductlineRow(row);
      this.closeDialog();
      this.loadRows();
    },
    onEdit(row) {
      this.editedRow = { ...row };
      this.showAddEditDialog = true;
    },
    onRemove(rowId) {
      const deletedRow = this.rows.find(row => { return row.id === rowId });
      this.rows = this.rows.filter(row => row.id !== rowId);
      this.rest.deleteProductlineRow(rowId);
      GeneralConfigService.removeEnabledProductLine(deletedRow)
      this.showDeleteConfirmDialog = false;
    },
    closeDialog() {
      this.showAddEditDialog = false;
      this.editedRow = false;
    },
    confirmDelete(row) {
      this.selectedRow = row;
      this.showDeleteConfirmDialog = true;
    }
  }
}
</script>

<style lang="scss" scoped>
  >>> .vue-table {
    border: 0;

    th, td {
      border-right: 0;
      border-bottom: 0;
      border-left: 0;
    }

    thead > tr > th {
      padding-right: .75rem;
      padding-left: 30px !important;
    }

    .arrow:before {
      bottom: 12px;
      right: auto;
      left: 12px;
      font-family: 'FontAwesome', sans-serif;
    }

    .icon-button {
      opacity: 0;
      transition: opacity .1s ease-out;
    }

    tr:hover .icon-button {
      opacity: 1;
    }
  }

  .actions {
    position: absolute;
    z-index: 1;
    top: 10px;
    right: 0;

    .icon-button {
      padding-right: 15px;
      padding-left: 50px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/productline/ProductlineTable.vue